export default "__VITE_ASSET__b45f2e43__"